// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaUserGraduate,
//   FaEnvelope,
//   FaLock,
// } from "react-icons/fa";

// const STUDENT_CREDENTIALS = {
//   email: "bhaskar@gmail.com",
//   password: "Bhaskar@2026",
// };

// function StudentLoginPage() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//   });

//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });

//     setError("");
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     if (
//       formData.email.trim().toLowerCase() ===
//         STUDENT_CREDENTIALS.email.toLowerCase() &&
//       formData.password === STUDENT_CREDENTIALS.password
//     ) {
//       localStorage.setItem("studentAuth", "true");

//       localStorage.setItem(
//         "studentUser",
//         JSON.stringify({
//           name: "Bhaskar",
//           email: STUDENT_CREDENTIALS.email,
//         })
//       );

//       navigate("/student/materials");
//     } else {
//       setError("Invalid Email or Password");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-r from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center px-4">
//       <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden">

//         <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-center py-8">
//           <FaUserGraduate className="mx-auto text-6xl mb-4" />

//           <h1 className="text-4xl font-bold">
//             Student Login
//           </h1>

//           <p className="mt-2 text-blue-100">
//             Linkin Professionals LMS
//           </p>
//         </div>

//         <form
//           onSubmit={handleLogin}
//           className="p-8"
//         >
//           {error && (
//             <div className="mb-5 bg-red-100 text-red-700 p-3 rounded-lg">
//               {error}
//             </div>
//           )}

//           <div className="mb-5">
//             <label className="block mb-2 font-semibold">
//               Email
//             </label>

//             <div className="relative">
//               <FaEnvelope className="absolute top-4 left-4 text-gray-400" />

//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter your email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 className="w-full pl-12 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//           </div>

//           <div className="mb-6">
//             <label className="block mb-2 font-semibold">
//               Password
//             </label>

//             <div className="relative">
//               <FaLock className="absolute top-4 left-4 text-gray-400" />

//               <input
//                 type="password"
//                 name="password"
//                 placeholder="Enter your password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 className="w-full pl-12 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-bold text-lg hover:opacity-90"
//           >
//             Login
//           </button>

//         </form>
//       </div>
//     </div>
//   );
// }

// export default StudentLoginPage;
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function StudentLoginPage() {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");

// //   const handleLogin = (e) => {
// //     e.preventDefault();

// //     // Demo credentials
// //     if (
// //       email === "student@gmail.com" &&
// //       password === "Student@123"
// //     ) {
// //       localStorage.setItem("studentAuth", "true");

// //       localStorage.setItem(
// //         "studentUser",
// //         JSON.stringify({
// //           name: "Student",
// //           email: email,
// //         })
// //       );

// //       navigate("/student/materials");
// //     } else {
// //       setError("Invalid Email or Password");
// //     }
// //   };
// const handleLogin = (e) => {
//   e.preventDefault();

//   console.log("Login Button Clicked");
//   console.log(email, password);

//   if (
//     email === "student@gmail.com" &&
//     password === "Student@123"
//   ) {
//     console.log("Login Success");

//     localStorage.setItem("studentAuth", "true");

//     localStorage.setItem(
//       "studentUser",
//       JSON.stringify({
//         name: "Student",
//         email: email,
//       })
//     );

//     navigate("/student/materials");
//   } else {
//     console.log("Login Failed");
//     setError("Invalid Email or Password");
//   }
// };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "#f4f6f9",
//       }}
//     >
//       <div
//         style={{
//           width: "400px",
//           background: "#fff",
//           padding: "30px",
//           borderRadius: "10px",
//           boxShadow: "0 0 15px rgba(0,0,0,0.2)",
//         }}
//       >
//         <h2 style={{ textAlign: "center" }}>Student Login</h2>

//         {error && (
//           <p style={{ color: "red", textAlign: "center" }}>
//             {error}
//           </p>
//         )}

//         <form onSubmit={handleLogin}>
//           <div style={{ marginBottom: "15px" }}>
//             <label>Email</label>

//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Enter Email"
//               style={{
//                 width: "100%",
//                 padding: "10px",
//                 marginTop: "5px",
//               }}
//             />
//           </div>

//           <div style={{ marginBottom: "20px" }}>
//             <label>Password</label>

//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter Password"
//               style={{
//                 width: "100%",
//                 padding: "10px",
//                 marginTop: "5px",
//               }}
//             />
//           </div>

//           <button
//             type="submit"
//             style={{
//               width: "100%",
//               padding: "12px",
//               background: "#2563eb",
//               color: "#fff",
//               border: "none",
//               borderRadius: "5px",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//           >
//             Login
//           </button>
//         </form>

//         <p style={{ marginTop: "20px", textAlign: "center" }}>
//           <strong>Demo Login</strong>
//           <br />
//           Email: student@gmail.com
//           <br />
//           Password: Student@123
//         </p>
//       </div>
//     </div>
//   );
// }

// export default StudentLoginPage;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const STUDENT_USERS = [
  { name: "Mayur", email: "Mayur@linkinprofessionals.com", password: "Mayur@vlinkin2026" },
  { name: "Swasthika", email: "Swasthika@linkinprofessionals.com", password: "Swasthika@vlinkin2026" },
  { name: "Tasmiyatabassum", email: "Tasmiyatabassum@linkinprofessionals.com", password: "Tasmiyatabassum@vlinkin2026" },
  { name: "Nisarga", email: "Nisarga@linkinprofessionals.com", password: "Nisarga@vlinkin2026" },
];

function StudentLoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    const matchedUser = STUDENT_USERS.find(
      (user) =>
        user.email.toLowerCase() === email.trim().toLowerCase() &&
        user.password === password
    );

    if (matchedUser) {
      localStorage.setItem("studentAuth", "true");

      localStorage.setItem(
        "studentUser",
        JSON.stringify({
          name: matchedUser.name,
          email: matchedUser.email,
        })
      );

      navigate("/student/materials", { replace: true });
    } else {
      setError("Invalid Email or Password");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f6f9",
      }}
    >
      <div
        style={{
          width: "400px",
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 0 15px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Student Login</h2>

        {error && (
          <p style={{ color: "red", textAlign: "center" }}>
            {error}
          </p>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "15px" }}>
            <label>Email</label>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
              }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label>Password</label>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default StudentLoginPage;